import { Hub } from 'aws-amplify/utils';
import React from 'react';

Hub.listen('auth', ({ payload }) => {
  const { event, data } = payload as { event: string; data?: { message: string }};
  if ((event as string) === 'cognitoHostedUI_failure') {
    setTimeout(() => {
      window.postMessage({ type: event, data }, window.location.origin);
    }, 1000);
  }
});

export default function useCognitoHostedUIError() {
  React.useEffect(() => {
    function listener(event: MessageEvent) {
      if (event.origin === window.location.origin) {
        if (event.data.type && event.data.type === 'cognitoHostedUI_failure') {
          const errorMessage = event.data.data.message.replace(/\+/g, ' ').replace(/%3A/g, ':').replace(/%3D/g, '');
          console.error(`Error signing in with SSO: ${errorMessage}`);
          window.location.hash = `sso_error=${errorMessage}`;
        }
      }
    }
    window.addEventListener('message', listener);
    return () => {
      window.removeEventListener('message', listener);
    };
  }, []);
}
